export enum ReturnForm
{
    Unset = "Unset",
    Package = "Package",
    Inpost = "Inpost",
    Personal = "Personal",
}

export const ReturnFormValueToLabel = {
    [ReturnForm.Unset]: "(nie wybrano formy zwrotu)",
    [ReturnForm.Package]: "Paczka",
    [ReturnForm.Personal]: "Zwrot osobisty",
    [ReturnForm.Inpost]: "Paczkomat Inpost",
}